import React, {Component} from 'react';
import ReactSVG from 'react-svg';
import { FormattedMessage } from 'react-intl';

import AppIcon from './../../assets/img/appIcon.png';
import CloseIcon from './../../assets/img/close-icon-white.svg';

import styles from './DownloadAppBar.module.css';
import Button from './../../components/button/Button';

import StoreUrls from './../../assets/json/storeUrls';

class DownloadAppBar extends Component {

    constructor(props){
        super(props);
        this.lastPageYOffset = 0;
        this.state = {
            closed: false,
        }

        this.hide = this.hide.bind(this);
        this.goToApp = this.goToApp.bind(this);
    }

    hide(){
        this.setState({
            closed: true
        });
    }

    goToApp(){
        window.location = "descubra-manaus://br.gov.am.manaus.descubra";
        setTimeout(function () {
            if ((navigator.platform.indexOf("iPhone") != -1) ||
                (navigator.platform.indexOf("iPad") != -1) ||
                (navigator.platform.indexOf("iPod") != -1)){
                window.location = StoreUrls.appStore;
            }else{
                window.location = StoreUrls.googlePlay;
            }
        }, 1000);
    }

    render(){
        let animation = "animated slideInUp delay-transition";

        if(!this.state.closed){
            return (
                <div className={[animation, styles.navBarContainer].join(' ')}>
                    <div className={styles.buttonsContainer}>
                        <ReactSVG src={CloseIcon} onClick={this.hide} className={styles.closeButton}/>
                        <div className={styles.AppIcon}>
                            <img src={AppIcon} />
                        </div>
                        <p>
                            <FormattedMessage id="downloadApp" />
                        </p>
                        <Button onClick={this.goToApp} className={styles.openButton} styleType="reverse">
                            <FormattedMessage id="install" />
                        </Button>
                    </div>
                </div>
            );
        }else{
            return (
                <div></div>
            )
        }

    }

}

export default DownloadAppBar;